// library imports
import { UnorderedListOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Col,
  Flex,
  Layout,
  Menu,
  Popover,
  Row,
  theme,
} from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import siteLogo from "../assets/site_logo.png";
import siteLogoDark from "../assets/site_logo_dark.png";
import { IndexContext } from "../context/IndexContext";
import useAuthCheck from "../hooks/useAuthCheck";
import useNavMenu from "./NavMenu";
import ProfileMenu from "./ProfileMenu";

function MainLayout() {
  // create a ref to point to the layout DOM
  const layoutRef = useRef();

  // get nav menu
  const [NavMenu, header_height] = useNavMenu();

  // load auth checker
  const [authenticationState, getAuthenticationState] = useAuthCheck();

  // use context
  const index_context = useContext(IndexContext);

  // get the token of current theme
  const { token } = theme.useToken();

  // for navigation
  const navigate = useNavigate();
  const location = useLocation();
  // for top menu collapse to sidebar
  const [collapsed, setCollapsed] = useState(true);
  // for getting current selected menu key
  const [menuSelectedKey, setMenuSelectedKey] = useState("Dashboard");

  const { isLightTheme } = useContext(IndexContext);

  // styles
  const headerStyle = {
    textAlign: "center",
    height: header_height,
    paddingInline: 0,
    lineHeight: header_height,
    position: "sticky",
    top: 0,
    zIndex: 1,
  };

  const contentStyle = {
    height: "calc(100% -" + header_height + " )",
    width: "100vw",
    minWidth: "100vw",
    overflow: "auto",
    padding: 10,
  };

  const layoutStyle = {
    overflow: "hidden",
    padding: 0,
    margin: 0,
    width: "100%",
    height: "100vh",
  };

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setMenuSelectedKey(path.charAt(0).toUpperCase() + path.slice(1));
  }, [location]);

  return (
    <Layout style={layoutStyle} ref={layoutRef}>
      <Layout.Header style={headerStyle}>
        <Card
          style={{
            height: "100%",
            width: "100%",
            borderRadius: 0,
            margin: 0,
          }}
          styles={{
            body: {
              height: "100%",
              width: "100%",
              borderRadius: 0,
              paddingBlock: 0,
              paddingLeft: 12,
            },
          }}
          bordered={false}
        >
          <Row style={{ height: "100%" }}>
            <Col xl={0} flex="52px">
              <Flex align="center" style={{ height: "100%", width: "100%" }}>
                <Button
                  icon={<UnorderedListOutlined />}
                  type="text"
                  size="large"
                  onClick={() => setCollapsed(!collapsed)}
                />
              </Flex>
            </Col>
            <Col flex="auto" style={{ height: "100%", paddingLeft: 0 }}>
              <Flex
                justify="space-between"
                align="center"
                style={{ height: "100%", width: "100%" }}
              >
                <img
                  src={isLightTheme ? siteLogo : siteLogoDark}
                  alt="Mixed_Rice"
                  style={{
                    height: "50%",
                  }}
                />
                <Row style={{ height: "100%" }}>
                  <Col
                    style={{ height: "100%" }}
                    xs={0}
                    sm={0}
                    md={0}
                    lg={0}
                    xl={24}
                  >
                    <Menu
                      style={{
                        height: "100%",
                        minWidth: 900,
                        borderBottom: 0,
                      }}
                      mode="horizontal"
                      items={NavMenu}
                      onClick={(item) => {
                        // check login user before navigate
                        getAuthenticationState({});

                        let path = "";
                        item.keyPath.reverse().map((value) => {
                          path = path + "/" + value;
                        });
                        navigate(path);
                      }}
                      onSelect={(item) => {
                        setMenuSelectedKey(item.key);
                      }}
                      selectedKeys={menuSelectedKey}
                    ></Menu>
                  </Col>
                </Row>
                <Popover
                  placement="bottom"
                  contentStyle={{ marginTop: "50px" }}
                  content={<ProfileMenu />}
                  arrow={false}
                  trigger="hover"
                  overlayInnerStyle={{
                    borderRadius: 0,
                    marginTop: 10,
                    padding: 0,
                  }}
                >
                  <Avatar style={{ backgroundColor: token["blue-6"] }}>
                    DM
                  </Avatar>
                </Popover>
              </Flex>
            </Col>
          </Row>
        </Card>
      </Layout.Header>
      <Layout>
        <Layout.Sider
          breakpoint="xl"
          collapsedWidth="0"
          width="300"
          collapsible
          trigger={null}
          collapsed={collapsed}
          onBreakpoint={() => setCollapsed(true)}
        >
          <Menu
            mode="inline"
            inlineIndent={32}
            style={{ height: "100%" }}
            items={NavMenu}
            onClick={(item) => {
              // check login user before navigate
              getAuthenticationState({});

              let path = "";
              item.keyPath.reverse().map((value) => {
                path = path + "/" + value;
              });
              navigate(path);
            }}
            onSelect={(item) => setMenuSelectedKey(item.key)}
            selectedKeys={menuSelectedKey}
          ></Menu>
        </Layout.Sider>
        <Layout.Content style={contentStyle}>
          {/* add layoutRef into the IndexContext */}
          <IndexContext.Provider
            value={{
              ...index_context,
              layoutRef: layoutRef,
              authenticationState: authenticationState,
            }}
          >
            <Outlet></Outlet>
          </IndexContext.Provider>
        </Layout.Content>
      </Layout>
    </Layout>
  );
}

export default MainLayout;
